// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__1oino","productName":"Table_productName__rkXnh"};